// extracted by mini-css-extract-plugin
module.exports = {"SaveMoney":"SaveMoney_SaveMoney__LqgCS","TabComp":"SaveMoney_TabComp__90xrN"};